import { ButtonProps, ButtonType, DialogFooterButtonsWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '../../../codegen/Localize';
import { IServerVersionInfo } from '../../../sessionManagement/serverApi/types/ISessionInfo';

export namespace AboutTableauServerDialog {

  export function Title() {
    return Messages.aboutTableau();
  }

  export function Content(props: AboutTableauServerDialog.Props) {
    return (
      <div>
        <Version {...props} />
        { props.podId && <PodId {...props} /> }
        <Copyright {...props} />
      </div>
    );
  }

  function Version(props: AboutTableauServerDialog.Props) {
    const { version } = props;
    const versionText = [
      Messages.serverVersion(),
      version.externalVersion.major + '.' + version.externalVersion.minor + '.' + version.externalVersion.patch,
      '(' + version.build + ')',
      version.bitness + Messages.bitSuffix(),
      version.platform,
      version.containerDeploymentType
    ].join(' ');

    return <div>{ versionText }</div>;
  }

  function PodId(props: AboutTableauServerDialog.Props) {
    return <div className="tb-pod-id">{ Messages.podId({ POD_ID: props.podId }) }</div>;
  }

  const CopyrightSign = '\u00A9';
  function Copyright(props: AboutTableauServerDialog.Props) {
    return <div className="tb-copyright">{ CopyrightSign + Messages.copyright() }</div>;
  }

  export function Footer(props: AboutTableauServerDialog.Props) {
    const CloseButtonProps: ButtonProps = {
      buttonType: ButtonType.Outline,
      handleClick: props.dismiss,
      testId: 'about-dialog-button',
      children: Messages.close()
    };

    return <DialogFooterButtonsWidget buttons={[ CloseButtonProps ]} testId="about-dialog-footer" />;
  }

  export interface Props {
    dismiss: () => void;
    version: IServerVersionInfo;
    podId: string;
  }
}
